import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const EquipmentStatusList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingEquipmentStatus', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)  
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'EquipmentStatus'}
            api='secondary'
            showTitle={true}
            title={'Equipment Status'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/equipmentStatusCrud', 'Create', t('Add')+' '+t('EquipmentStatus'), row)],
                ['Edit', (row) => newRoute('containerControl/equipmentStatusCrud', 'Edit', t('Edit')+' '+t('EquipmentStatus'), row)],
                ['Copy', (row) => newRoute('containerControl/equipmentStatusCrud', 'Copy', t('Copy')+' '+t('EquipmentStatus'), row)]
            ])}
        />
    )
}